export default "__VITE_ASSET__CixGqLqe__"